import { companiesTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: false,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case companiesTypes.GET_COMPANIES__REQUEST: return {
      ...state,
      isRequesting: true
    }
    case companiesTypes.GET_COMPANIES__SUCCESS: return {
      ...state,
      isRequesting: false,
      items: action.payload.items
    }
    default:
      return state
  }
}
